module.exports = __webpack_public_path__ + "img/slow_logo_white.f619fd2e.png";